export const getHeatmapConfigLux = (name, radius = 20) => {
  return {
    id: "lux",
    type: "heatmap",
    config: {
      dataId: "lux",
      label: "point",
      color: [253, 236, 0],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer YlOrRd-6",
          type: "sequential",
          category: "ColorBrewer",
          colors: [
            "#ffffb2",
            "#fed976",
            "#feb24c",
            "#fd8d3c",
            "#f03b20",
            "#bd0026",
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: { name: name, type: "real" },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: name,
        type: "real",
      },
      weightScale: "linear",
    },
  };
};

export const getHeatmapConfigLuxNorm = (radius = 25) => {
  return {
    id: "lux",
    type: "heatmap",
    config: {
      dataId: "lux",
      label: "point",
      color: [253, 236, 0],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 1,
        colorRange: {
          name: "ColorBrewer YlOrRd-6",
          type: "sequential",
          category: "ColorBrewer",
          colors: [
            "#ffffb2",
            "#fed976",
            "#feb24c",
            "#fd8d3c",
            "#f03b20",
            "#bd0026",
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: { name: 'data_norm', type: "real" },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: 'data_norm',
        type: "real",
      },
      weightScale: "linear",
    },
  };
};